import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { ElementLinkModel } from 'src/app/ViewModel/ElementLinkModel';
import { ModuleModel } from 'src/app/ViewModel/ModuleModel';
import { CommonService } from '../Common.service';
import { MapRoleFeatureService } from '../map-role-feature/map-role-feature.service';
import { RestApiService } from '../rest-api.service';

@Injectable({
	providedIn: 'root'
})
export class ElementLinkService {

	businessGroupList: ReadonlyArray<BusinessGroupModel> = [];
	selectedBusinessGrpId?: number | null;
	clearBusinessGroup = 'N';

	endpoints = {
		module: {
			'getModuleList': 'CECED/GetCEDAgainstCE',
		},
		elementLink: {
			'getDocumentElements': 'ElementLink/GetProjectDocumentElements',
			'getModuleElements': 'ElementLink/GetProjectModuleElements',
			'getDependentFlag': 'ElementLink/GetProjectDependantDocumentElement',
			'saveDocumentElements': 'ElementLink/PostProjectDocumentElements',
			'getNumberingSlNoLength': 'ElementLink/GetProjectNumberingSerialLength',
		},
	}

	constructor(private mapRoleFeatureService: MapRoleFeatureService,
		private commonService: CommonService,
		private restApiService: RestApiService,
	) {
		this.commonService.selectedProjectId.subscribe((data: any) => {
			if (data != null || data != undefined) {
				this.getBusinessGrpList(data);
			}
		});
	}


	getBusinessGrpList(projectId: number) {
		this.mapRoleFeatureService.getBusinessGroups(projectId).subscribe(data => {
			this.businessGroupList = data.filter(each => each.is_Active);
		});
	}

	getDocumentElements(projectId: number, isForStaticElement: boolean, businessGroupId?: number, moduleId?: number, isForAllElements?: boolean): Observable<ElementLinkModel[]> {
		let reqData = {
			projectId,
			groupId: this.selectedBusinessGrpId ? this.selectedBusinessGrpId : businessGroupId,
			moduleId: moduleId ? moduleId : null,
			"isQueryForStaticElement": isForStaticElement,
			"isQueryForAllElements": isForAllElements,
		}
		return this.restApiService.new_POST(this.endpoints.elementLink.getDocumentElements, reqData);
	}

	getModuleElements(projectId: number, groupId: number, moduleId: string, moduleCount: number) {
		let reqData = { projectId, groupId, moduleId, moduleCount };
		return this.restApiService.new_POST(this.endpoints.elementLink.getModuleElements, reqData);
	}


	getModuleList(businessGroupId: number): Observable<ModuleModel[]> {
		let reqData = {
			"projectId": this.commonService.getProjectId(),
			"groupId": businessGroupId,
			"ceDescription": "Module",
		};
		return this.restApiService.new_POST(this.endpoints.module.getModuleList, reqData);

	}

	saveDocumentElements(reqData: any) {
		return this.restApiService.new_POST(this.endpoints.elementLink.saveDocumentElements, reqData);
	}

	getDependentFlag(groupId: string, moduleId: string | null, parentElementId: number) {
		let reqData = {
			"projectId": this.commonService.getProjectId(),
			groupId,
			moduleId,
			parentElementId,
		}
		return this.restApiService.new_POST(this.endpoints.elementLink.getDependentFlag, reqData);
	}

	getNumberingSlNoLength(projectId: number, groupId: number, moduleId: number) {
		let reqData = {
			projectId,
			groupId,
			moduleId
		}
		return this.restApiService.new_POST(this.endpoints.elementLink.getNumberingSlNoLength, reqData);
	}

}
